import React from 'react';

const Navbar=(props)=>{
    return (
        <div className="ui container no-scroll" style={{width:"100%", overflow:"scroll", borderBottom:"2px solid rgba(34,36,38,.15)"}}>
            <div className={"ui large secondary pointing menu "+props.color}>
                <a href="/decider/#/" className={props.active === "landing" ? "toc item active" : "toc item"}>
                    <i className="home icon"></i>
                </a>
                    <a href="/decider/#/decision" className={props.active === "decision" ? "item active" : "item"} >Decision Maker</a>
                    <a href="/decider/#/lucky" className={props.active === "lucky" ? "item active" : "item"} >Lucky Meter</a>
                    <a href="/decider/#/" className={props.active === "prophecy" ? "item active" : "item"} >Prophetic Question (coming soon!)</a>
                <div className="right item">
                    <a href="/" className="ui button">About Me!</a>
                </div>
            </div>
        </div>
    );
}

export default Navbar;